import { TagColor } from '@/lib/enums';
import TagColors from '../colors/Tag';

export default function tagColor({
  color = TagColor.GREY_REGULAR,
  state = 'active',
  property = null,
} = {}) {
  const currentColor = color || TagColor.GREY_REGULAR;
  const [name, variant] = currentColor.toLowerCase().split('_');

  const properties = TagColors[name][variant][state];
  return property ? properties.normal[property] : properties;
}
